// ! Lembrar de alinhar sempre ao que tem no BACKEND
const EquipmentEnum = {
  AVAILABLE: 1,
  RENTED: 2,
  RESERVED: 3,
  BORROWED: 4,
  INTERNAL_USE: 5,
  MAINTENANCE: 6,
  WARRANTY: 7,
  RETURNED: 8,
  DISABLED: 9,
  AWAITING_SHIPMENT: 10,
  ON_THE_WAY: 11,
  AWAITING_MOVEMENT: 12,
  AWAITING_REPLACEMENT: 13,
  REMOVED_FROM_SHIPMENT: 15,
};

const EquipmentEnumPtBRLabelById = {
  [EquipmentEnum.AVAILABLE]: "DISPONÍVEL PARA LOCAÇÃO",
  [EquipmentEnum.RENTED]: "ALUGADO",
  [EquipmentEnum.RESERVED]: "RESERVADO",
  [EquipmentEnum.BORROWED]: "EMPRESTADO",
  [EquipmentEnum.INTERNAL_USE]: "USO INTERNO",
  [EquipmentEnum.MAINTENANCE]: "EM MANUTENÇÃO",
  [EquipmentEnum.WARRANTY]: "NA GARANTIA",
  [EquipmentEnum.RETURNED]: "EM DEVOLUÇÃO",
  [EquipmentEnum.DISABLED]: "BAIXADO",
  [EquipmentEnum.AWAITING_SHIPMENT]: "AGUARDANDO CARREGAMENTO",
  [EquipmentEnum.ON_THE_WAY]: "EM ROTA",
  [EquipmentEnum.AWAITING_MOVEMENT]: "AGUARDANDO MOVIMENTAÇÃO",
  [EquipmentEnum.AWAITING_REPLACEMENT]: "AGUARDANDO SUBSTITUIÇÃO",
  [EquipmentEnum.REMOVED_FROM_SHIPMENT]: "RETIRADO DO CARREGAMENTO",
};

export { EquipmentEnum, EquipmentEnumPtBRLabelById };
